import Button from "@components/Button";
import CustomInput, {
    CustomSelectInput
} from "@components/CustomInput/CustomInput";
import TableComponent from "@components/TableComponent/TableComponent";
import usePrice from "@hooks/usePrice";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";

import styles from "./ManagePricePage.module.css";
import { Home } from "@mui/icons-material";

const ManagePricePage = () => {
    const navigate = useNavigate();
    const { handleGetPrice } = usePrice();
    const { priceData } = useSelector((state) => state.price);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [page, setPage] = useState(0);

    const [searchFilters, setSearchFilters] = useState({
        doctorId: "",
        myReferenceNumber: "",
        registeredEmail: "",
        contact: "",
        firstName: "",
        instituteName: "",
        pincode: "",
        order: "",
    });

    const handleNavigateAddPricePanel = () => {
        navigate("/manageprice/add");
    }

    const handleNavigatePriceDetail = (myReferenceNumber) => {
        navigate(`/manageprice/${myReferenceNumber}`);
    }

    function createData(
        doctorId,
        myReferenceNumber,
        registeredEmail,
        contact,
        firstName,
        instituteName,
        pincode,
        created_at,
        updated_at
    ) {
        // Helper function to safely format dates
        const formatDate = (date) => {
            const parsedDate = new Date(date);
            return isNaN(parsedDate) ? "Invalid Date" : parsedDate.toISOString().split("T")[0];
        };
    
        return {
            doctorId,
            myReferenceNumber,
            registeredEmail,
            contact,
            firstName,
            instituteName,
            pincode,
            created_at: formatDate(created_at), // Safely format the date
            updated_at: formatDate(updated_at),
            actions: (
                <Button
                    text={"view"}
                    onClick={() => handleNavigatePriceDetail(myReferenceNumber)}
                />
            ),
        };
    }
    

    const rows = Array.isArray(priceData?.data) && priceData.data.length > 0
    ? priceData.data.map((price) =>
        createData(
            price.doctorId,
            price.myReferenceNumber,
            price.registeredEmail,
            price.contact,
            price.firstName,
            price.instituteName,
            price.pincode,
            price.created_at,
            price.updated_at
        )
    )
    : [];

    const columns = [
        { id: "doctorId", label: "Doctor ID", minWidth: 170 },
        { id: "myReferenceNumber", label: "My Reference Number", minWidth: 170 },
        { id: "registeredEmail", label: "Registered Email", minWidth: 170 },
        { id: "contact", label: "Contact", minWidth: 170 },
        { id: "firstName", label: "First Name", minWidth: 170 },
        { id: "instituteName", label: "Institute Name", minWidth: 170 },
        { id: "pincode", label: "Pincode", minWidth: 170 },
        // { id: "settledPrice", label: "Settled Price", minWidth: 170 },
        { id: "created_at", label: "Created At", minWidth: 170 },
        { id: "updated_at", label: "Updated At", minWidth: 170 },
        { id: "actions", label: "Actions", minWidth: 170 }
    ];

    const sortByOptions = [
        { option: "Registered Email", value: "registeredEmail" },
        { option: "Create Date", value: "created_at" },
        { option: "Update Date", value: "updated_at" }
    ]

    const orderByOptions = [
        { option: "Ascending", value: 1 },
        { option: "Descending", value: -1 }
    ];

    const handleNavigateDashboard = () => {
        navigate("/");
    }

    const handleNavigateDoctorPanel = () => {
        navigate("/managedoctor");
    }

    const handleSearchInput = ({ target }) => {
        const { name, value } = target;
        setSearchFilters((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    }

    const tableHeads = [
        {
            component: (
                <CustomInput
                    align={"left"}
                    className={styles.Input}
                    showSearchIcon
                    name="doctorId"
                    value={searchFilters.doctorId}
                    onChange={handleSearchInput}
                />
            )
        },
        {
            component: (
                <CustomInput
                    align={"left"}
                    className={styles.Input}
                    showSearchIcon
                    name="myReferenceNumber"
                    value={searchFilters.myReferenceNumber}
                    onChange={handleSearchInput}
                />
            )
        },
        {
            component: (
                <CustomInput
                    align={"left"}
                    className={styles.Input}
                    showSearchIcon
                    name="registeredEmail"
                    value={searchFilters.registeredEmail}
                    onChange={handleSearchInput}
                />
            )
        },
        {
            component: (
                <CustomInput
                    align={"left"}
                    className={styles.Input}
                    showSearchIcon
                    name="contact"
                    value={searchFilters.contact}
                    onChange={handleSearchInput}
                />
            )
        },
        {
            component: (
                <CustomInput
                    align={"left"}
                    className={styles.Input}
                    showSearchIcon
                    name="firstName"
                    value={searchFilters.firstName}
                    onChange={handleSearchInput}
                />
            )
        },
        {
            component: (
                <CustomInput
                    align={"left"}
                    className={styles.Input}
                    showSearchIcon
                    name="instituteName"
                    value={searchFilters.instituteName}
                    onChange={handleSearchInput}
                />
            )
        },
        {
            component: (
                <CustomInput
                    align={"left"}
                    className={styles.Input}
                    showSearchIcon
                    name="pincode"
                    value={searchFilters.pincode}
                    onChange={handleSearchInput}
                />
            )
        },
        {
            component: (
                <div className={styles.Input}></div>
            )
        },
        {
            component: (
                <div className={styles.Input}></div>
            )
        },
        
    ];

    const searchFunction = () => {
        handleGetPrice({ ...searchFilters, page: page + 1, limit: rowsPerPage });
    }

    useEffect(() => {
        handleGetPrice({ ...searchFilters, page: page + 1, limit: rowsPerPage });
    }, [page, rowsPerPage, searchFilters.order, searchFilters?.sortBy]);

    return (
        <div>
            <div className={styles.MenuWrapper}>
                <div className={styles.NavigationWrapper}>
                    <Home className={styles.HomeIcon} onClick={handleNavigateDashboard} />{" "}
                    <div>
                        <span
                            className={styles.DashboardText}
                            onClick={handleNavigateDashboard}
                        >
                            Dashboard
                        </span>
                        <span className={styles.RouteText}>/Price Panel</span>
                    </div>
                </div>
                <div className={styles.ActionItemsWrapper}>
                    <Button
                        className={styles.BtnClass}
                        text={"Manage Doctor"}
                        btnType={"secondary"}
                        onClick={handleNavigateDoctorPanel}
                    />
                    <CustomSelectInput
                        className={styles.CustomSelect}
                        selectOptions={sortByOptions}
                        defaultOption={"Sort By"}
                        value={searchFilters.sortBy}
                        onChange={handleSearchInput}
                        name={"sortBy"}
                    />
                    <CustomSelectInput
                        selectOptions={orderByOptions}
                        className={styles.CustomSelect}
                        defaultOption={"Order By"}
                        name={"order"}
                        value={searchFilters.order}
                        onChange={handleSearchInput}
                    />
                    <Button
                        className={styles.BtnClass}
                        text={"Add Price"}
                        btnType={"secondary"}
                        onClick={handleNavigateAddPricePanel}
                    />
                </div>
            </div>
            
            <TableComponent
                tableHeads={tableHeads}
                columns={columns}
                rows={rows}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                page={page}
                setPage={setPage}
                totalRecords={priceData?.total_record ?? 0}
                searchFunction={searchFunction}
            />
        </div>
    );
};

export default ManagePricePage;